import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import app from './modules/app'
import session from './modules/session'
import account from './modules/account'
import user from './modules/user'
import role from './modules/role'
import tenant from './modules/tenant'
import purchase from './modules/purchase'
const store = new Vuex.Store({
    state: {
        //
        appInfoDataType: {
            单位基本信息: 1,
            申请人基本信息: 2,
            申请人婚姻信息: 3,
            配偶信息: 4,
            子女信息: 5,
            学历信息: 6,
            加分材料: 7,
            个人信息变更: 8,
            结果页: 9,
            专科学历信息: 16,
            补充材料信息: 18,
            previewCA: 19,
            QrSub: 20,
            补充材料其他材料: 22,
            线下添加同住人: 25,
            受理: 50,
            全部: 100//全部不包含补充材料信息
        },
          LHApplicationType: {
            人才引进落户: 21,
            居转户落户: 20,
            留学生落户: 22,
            解困落户:23,
        },
         fileVerificationInfoType: {
            '居住证积分档案单位': 1,//需要单位邮寄调档函、有调档函
            '档案在人才中心': 5,//由人才中心推送核档信,息,
            '落户档案在单位':10,//市网拿下来的档案表
            '无需核档':20,//市网拿下来的档案表
        },
        applicationType:
        {
            '居住证积分新办': 1,
            '密码重置': 2,
            '单位开户/单位信息变更': 3,
            '有效期内变更单位': 4,
            '积分有效期内变更居住地址': 5,
            '单位撤回申请': 6,
            '注销申请人积分、配偶子女信息': 7,
            '居住证积分续办': 8,
            '有效期内添加同住人': 9
        },//所有申请类型
        otherApplicationType:
        {
            '密码重置': 1,
            '单位开户/单位信息变更': 2,
            '有效期内变更单位': 3,
            '积分有效期内变更居住地址': 4,
            '单位撤回申请': 5,
            '注销申请人积分、配偶子女信息': 6,
        },//所有申请类型
        cnEducationType: {
            "普通高等教育": 1,
            "成人高等教育": 2,
            "高等教育自学考试": 3,
            "网络教育": 4,
            "中等教育": 5,
            "开放教育": 6,
            "开放教育(八一、总参学院)": 7,
            '军队院校成人教育': 8,
            '解放军高等教育自学考试': 9,
        },

        logoutObjectTypeList: [{ text: "本人", value: 1 }, { text: "配偶/子女", value: 5 }],
        resetPasswordType: {
            个人: 1,
            单位: 5,
        },
        syncRYXXApplicationType: {
            新办: 1,
            续办: 2,

        },
        applicationSourceTypes: { 线上: 1, 线下: 5 },
       passwordSourceTypes: { 单位: 5, 个人: 1 },
        registeredResidenceType: { 家庭户口: 1, 集体户口: 2 },
        registeredResidenceTypeList: [{ text: "家庭户口", value: 1 }, { text: "集体户口", value: 2 }],

        collectiveAccountMaterialsTypes: { 户口簿: 1, 派出所出具的户籍证明: 5 },
        collectiveAccountMaterialsTypeList: [{ text:'户口簿',value: 1, }, {text:'派出所出具的户籍证明',value: 5 }],


        childTypeEnum: {
            '亲生': 1,
            '领养': 3,
            '继子女': 5
        },
        maritalStatusSet: {
            "初婚": 1,
            "未婚": 2,
            "离异": 3,
            "丧偶": 4,
            '再婚': 8,
        },
        materiaBasicData: { isBornByCurrentSpouseTypes: [], maritalStatusSet: {},registeredResidenceTypeList:[] },//积分新办所有枚举
        enterpriseHasLaborDispatchPermit: false,//公司有无劳动派遣资质
        enterpriseIsShanghaiBranch: false,//是否外地单位上海分公司
        isPassFilesManagementAptitude:false,//单位是否有档案管理资质
        otherApplicationTypeList: [
            {
                text: "密码重置",
                value: 1
            },
            {
                text: "单位开户/单位信息变更",
                value: 2
            },
            {
                text: "有效期内变更单位",
                value: 3
            },
            {
                text: "积分有效期内变更居住地址",
                value: 4
            },
            {
                text: "单位撤回申请",
                value: 5
            },
            {
                text: "注销申请人积分、配偶子女信息",
                value: 6
            }
        ],//其他申请类型下拉框

        globalAccept: 'image/*,application/pdf',
        globalFormat: ['jpg', 'png', 'jpeg', 'pdf'],

        isDisableEnterpriseAgentInput: false,//新办申请 经办人是否可选
        isPerson: false,//是否个人申请
        resetPasswordShowType: 6,//密码重置显示新密码 6==已受理
    },
    mutations: {
        // 在这里定义修改状态的方法
        setMateriaBasicData(state, option) {
            //积分新办所以枚举
            console.log('materiaBasicData', option);
            state.materiaBasicData = { ...option }
            state.materiaBasicData.maritalStatusSet = {
                "初婚": 1,
                "未婚": 2,
                "离异": 3,
                "丧偶": 4,
                '再婚': 8,
            }
        }
    },
    actions: {
    },
    modules: {
        app,
        session,
        account,
        user,
        role,
        tenant,
        purchase,
    }
});

export default store;